import { render } from "./createUsersComponent.vue?vue&type=template&id=61ec183b&scoped=true"
import script from "./createUsersComponent.vue?vue&type=script&lang=js"
export * from "./createUsersComponent.vue?vue&type=script&lang=js"

import "./createUsersComponent.vue?vue&type=style&index=0&id=61ec183b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ec183b"]])

export default __exports__